// extracted by mini-css-extract-plugin
module.exports = {"areaLateral":"style_areaLateral__kuXQ3","btnRetractExpand":"style_btnRetractExpand__39-LD","expanded":"style_expanded__2BmCE","textRecolherMenu":"style_textRecolherMenu__3DQRF"};